import classNames from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';

type IArticleProps = HTMLAttributes<HTMLElement>;

export function Article({
  children,
  className = '',
  ...rest
}: PropsWithChildren<IArticleProps>) {
  return (
    <article className={classNames(`flex w-full ${className}`)} {...rest}>
      {children}
    </article>
  );
}
